import {Link, type LinkProps} from "@mui/material";
import {createLink, type LinkComponent} from "@tanstack/react-router";
import * as React from "react";

interface MUILinkProps extends Omit<LinkProps, "href"> {}

const MUILinkComponent = React.forwardRef<HTMLAnchorElement, MUILinkProps>((props, ref) => {
    return <Link component={"a"} ref={ref} {...props} />;
});

const CreatedLinkComponent = createLink(MUILinkComponent);

const TanMuiLink: LinkComponent<typeof MUILinkComponent> = props => {
    return <CreatedLinkComponent preload={"intent"} {...props} />;
};

export default TanMuiLink;
